import { useEffect, useState } from "react";

/**
 * Tracks the `dark` class on <html> (tailwind darkMode: 'class'), the same
 * signal Default.layout.tsx and Home.view.tsx each poll with their own
 * MutationObserver. Not ThemeContext — that one tracks prefers-color-scheme,
 * not the class actually applied.
 */
export default function useIsDarkTheme(): boolean {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() =>
      setIsDark(document.documentElement.classList.contains("dark"))
    );
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
